import React, {useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {useCheckoutContext} from "../../CheckoutContextProvider/CheckoutContextProvider";
import {useCustomerSelector} from "../../../../store";
import Checkbox from "../../../lib/form/Checkbox/Checkbox";

const SummaryCustomerAccount: React.FC = () => {
  const {t} = useTranslation();
  const {checkout} = useCheckoutContext();
  const {customer} = useCustomerSelector();
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const wasGuest = useRef<boolean>(checkout.isGuest).current;

  const handleChange = () => {
    setIsChecked(prev => {
      const newValue = !prev;
      if (checkout.isGuest === newValue) {
        void checkout.put({isGuest: !newValue});
      }
      
      return newValue;
    });
  };

  if (customer.isLoggedIn || !wasGuest) {
    return null;
  }

  return (
    <div className="checkout-summary-option">
      <Checkbox
        wrapperClassName="checkbox__wrapper"
        className="checkbox--large"
        checked={isChecked}
        color={"green"}
        onChange={handleChange}
      >
        <strong>{t("checkout.createCustomerAccount")}</strong>
        {" " + t("checkout.benefitFromExclusiveOffers")}
      </Checkbox>
    </div>
  );
};

export default SummaryCustomerAccount;
